module.exports = __webpack_public_path__ + "static/img/IMG_20240810_161716.cab8bcfd.jpg";